import React, { useCallback } from "react";
import { PLUCategoryItemSpacer } from "./PLUCategoryItem/PLUCategoryItemSpacer";
import { Platform, Pressable } from "react-native";
import { useNavigation, useRoute } from "@react-navigation/native";
import { AHText, AHTextFonts, useLayoutContext, useTheme } from "arkh";

import * as Haptics from "expo-haptics";
import { graphql, useLazyLoadQuery } from "react-relay";
import { PLUCategorySelectorShowHiddenButtonQuery } from "./__generated__/PLUCategorySelectorShowHiddenButtonQuery.graphql";
import {
  UserLoggedInNavigatorNavigationProp,
  UserLoggedInNavigatorRouteProp,
} from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";

export function PLUCategorySelectorShowHidden(props: {
  categoriesShowing: ({ readonly id: string } | "ADD_ITEM")[];
}) {
  const theme = useTheme();
  const layout = useLayoutContext();

  const {
    params: { isShowingAllCategories, isEditing },
  } = useRoute<UserLoggedInNavigatorRouteProp<"TeamPLU">>();
  const navigation =
    useNavigation<UserLoggedInNavigatorNavigationProp<"TeamPLU">>();

  const onPressIn = useCallback(() => {
    if (Platform.OS === "ios") {
      Haptics.selectionAsync();
    }
  }, []);

  const selected = isShowingAllCategories;

  const onPress = useCallback(() => {
    navigation.setParams({
      isShowingAllCategories: !isShowingAllCategories,
    });
  }, [isShowingAllCategories, navigation]);

  const data = useLazyLoadQuery<PLUCategorySelectorShowHiddenButtonQuery>(
    graphql`
      query PLUCategorySelectorShowHiddenButtonQuery {
        pluCategories {
          id
        }
      }
    `,
    {}
  );

  const categoryIds = props.categoriesShowing.map((c) =>
    c === "ADD_ITEM" ? c : c.id
  );

  const showButton = data.pluCategories.some((plu) => {
    return !categoryIds.includes(plu.id);
  });
  if (!isEditing) {
    return null;
  }
  if (!showButton && !isShowingAllCategories) {
    return null;
  }
  return (
    <PLUCategoryItemSpacer>
      <Pressable
        style={(p) => ({
          flex: 1,
          flexDirection: "row",
          alignItems: "center",
          opacity: p.pressed ? 0.5 : 1,
          backgroundColor: selected ? theme.darkText : theme.background,
          paddingHorizontal: layout.space.xsmall,
          borderRadius: layout.radius.medium,
        })}
        onPressIn={onPressIn}
        onPress={onPress}
      >
        <AHText
          type="body"
          numberOfLines={1}
          font={selected ? AHTextFonts.BOLDER : AHTextFonts.MEDIUM}
          style={{
            flex: 1,
            textAlign: "center",

            color: selected ? theme.surface : theme.darkerText,
          }}
        >
          {selected ? "Visa avdelningens" : "Visa alla kategorier"}
        </AHText>
      </Pressable>
    </PLUCategoryItemSpacer>
  );
}
